export class FirmatarioDTO {
  cf: string;

  cmu: string;

  descrizione: string;
}
